import { useEffect, useRef } from "react"

/* A hook to listen click event outside of the ref element 
 and execute the callback function to handle the event triggered.*/
function useOutsideClick(isOpen, handler) {
  const ref = useRef()

  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler()
      }
    }

    const removeListener = () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      removeListener()
    }

    return () => {
      removeListener()
    }
  }, [handler, isOpen])

  return ref
}

export default useOutsideClick
